import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.dax = bracketIndenting()
